import { useEffect, useRef, useState } from "react";
import { fmt } from "@/lib/api";

// Public installment-table token supplied by PayTR's merchant panel; not an API key.
const TABLE_TOKEN = "b5ca80af64ce913aae72b1122d3161d5f52d811c67990ff48e876fcf062bce96";

export default function Installments({ packages }) {
  const [selected, setSelected] = useState("");
  const [height, setHeight] = useState(500);
  const frame = useRef(null);
  const pack = packages.find(p => p.id === selected) || packages[0];
  const amount = Number(pack?.grand_total);
  useEffect(() => {
    const resize = e => {
      if (e.source === frame.current?.contentWindow && e.data?.kind === "vezimza-installments-height"
          && Number.isFinite(e.data.height)) setHeight(Math.min(8000, Math.max(250, e.data.height)));
    };
    window.addEventListener("message", resize);
    return () => window.removeEventListener("message", resize);
  }, []);
  if (!pack || !Number.isFinite(amount) || amount <= 0) return null;
  const src = `https://www.paytr.com/odeme/taksit-tablosu/v2?token=${TABLE_TOKEN}&merchant_id=759799&amount=${amount.toFixed(2)}&taksit=0&tumu=0`;
  const html = `<!doctype html><html lang="tr"><meta name="viewport" content="width=device-width,initial-scale=1"><style>
    body{margin:0;font:14px Arial,sans-serif}#paytr_taksit_tablosu{clear:both;font-size:12px;text-align:center}
    .taksit-tablosu-wrapper{box-sizing:border-box;margin:5px;max-width:100%;width:280px;padding:12px;text-align:center;display:inline-block;border:1px solid #e1e1e1;vertical-align:top}
    .taksit-logo img{max-height:28px;padding-bottom:10px}.taksit-tutari-text{float:left;width:120px;color:#666;margin-bottom:5px}
    .taksit-tutar-wrapper{display:inline-block;background:#f7f7f7}.taksit-tutari{box-sizing:border-box;float:left;width:120px;padding:6px 0;color:#474747;border:2px solid white}.taksit-tutari-bold{font-weight:bold}
    </style><body><div id="paytr_taksit_tablosu">Taksit seçenekleri yükleniyor…</div>
    <script>const box=document.getElementById('paytr_taksit_tablosu');box.textContent='';new ResizeObserver(()=>parent.postMessage({kind:'vezimza-installments-height',height:document.body.scrollHeight+16},'*')).observe(document.body);</script>
    <script src="${src}" onerror="document.getElementById('paytr_taksit_tablosu').textContent='Taksit tablosu şu anda yüklenemiyor. Güncel seçenekleri PayTR ödeme ekranında görebilirsiniz.'"></script></body></html>`;
  return <section className="legal" data-testid="installment-section">
    <h2>Kredi kartına taksit seçenekleri</h2>
    <p>Vade farkı seçtiğiniz taksite göre müşteri toplamına eklenir. Kesin tutar PayTR ödeme ekranında gösterilir.</p>
    <label>Paket seçin<select value={pack.id} onChange={e => { setSelected(e.target.value); setHeight(500); }} data-testid="installment-package-select">
      {packages.map(p => <option key={p.id} value={p.id}>{`${p.name} · ${fmt(p.grand_total)} (kargo dahil)`}</option>)}
    </select></label>
    <p className="muted" data-testid="installment-pickup-note">Ücretsiz elden teslim seçerseniz kargo bedeli alınmaz; taksit tutarları ürün bedeli üzerinden hesaplanır.</p>
    <iframe ref={frame} key={pack.id + ":" + amount} title="PayTR taksit tablosu" sandbox="allow-scripts" srcDoc={html}
      style={{width:"100%",height,border:0,marginTop:16}} data-testid="installment-table" />
  </section>;
}
